/* this file added by Bearer Web Developer  */
import React from 'react';
import styles from './riderTime.module.scss';
import { useAppState } from '../../../states/app-state';

interface IShowSteps {

}
const RiderTime: React.FC<IShowSteps> = ({ }) => {

    const appState = useAppState();
    const selectedOrder = appState.selectedOrder;
    const time = selectedOrder?.rider?.path?.time;
    return (
        <div className={styles.rider_time}>
            <h5>Estimated Arrival Time</h5>
            <p>{time?.split(' ')[0]} <span>{time?.split(' ')[1]}</span></p>
        </div>
    )
}
export default RiderTime;